export default {
  label: {
    title: 'Applied Global Filters',
  },
};
